import { UIActions } from '../../../State/UI/UIActions';
import { StreakInfoPopupLayout } from '../../../Layouts/StreakBar/StreakInfoPopupLayout';
import BaseMenu from '../../../System/UI/Menu/BaseMenu';
import BaseUISystem from '../../../System/UI/BaseUISystem';
import { applyDefaultButtonAnimation } from '../../../System/UI/UIHelper';
import { GameObjectEvent } from '../../../GameObject/GameObject';
import Game from '../../../Game';
import { PopupID } from '../../../State/UI/PopupID';
import RelativePositionComponent from 'Component/Render/RelativePosition';
import Point from 'Utility/Point';
import { Layout } from '../../../Utility/layout/createLayout';

export default class StreakInfoPopup extends BaseMenu {
    private layout: any;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.STREAK_INFO_POPUP, uiSystem, false);
    }

    public onShow() {
        super.onShow();

        this.layout = new StreakInfoPopupLayout();
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        [this.layout.playButton, this.layout.closeButton]
            .forEach((button) => applyDefaultButtonAnimation(button));

        this.layout.closeButton.on(GameObjectEvent.SELECTED, this.continue);
        this.layout.playButton.on(GameObjectEvent.SELECTED, this.continue);
    }

    private readonly continue = (): void => {
        UIActions.hidePopup(this.name);
    };
}
